import React from "react";
import WebsiteHomePage from "../../components/Home/WebsiteHomePage";

const WebHome = () => {
    return (
        <>
            <WebsiteHomePage />
        </>
    );
};

export default WebHome;



